export const MAIN_COURTS = [
  "Court Suzanne Lenglen",
  "Court Philippe Chatrier",
  "Court Simonne Mathieu"
];

export const hasAnyMatches = (matches) =>
  (matches?.ended?.length || 0) +
    (matches?.live?.length || 0) +
    (matches?.upcoming?.length || 0) >
  0;

export const getDefaultTab = (matches) => {
  if (matches?.live?.length > 0) return "live";
  if (matches?.upcoming?.length > 0) return "upcoming";
  return "ended";
};

export const getMainCourtMatches = (sportsData, courtName) => {
  return sportsData?.matches?.filter((match) => match.court === courtName)[0];
};

const getOtherCourtKeys = (sportsData) => {
  if (!sportsData?.matches) return [];

  return Object.keys(sportsData.matches).filter(
    (court) => !MAIN_COURTS.includes(sportsData.matches[court]?.court)
  );
};

export const getOtherCourtsMatches = (sportsData) => {
  const otherCourtKeys = getOtherCourtKeys(sportsData);
  if (otherCourtKeys.length === 0) return null;

  return {
    court: "Other Courts",
    ended: otherCourtKeys.flatMap((court) =>
      (sportsData.matches[court]?.ended || []).map((match) => ({
        ...match,
        court: sportsData.matches[court]?.court
      }))
    ),
    live: otherCourtKeys.flatMap((court) =>
      (sportsData.matches[court]?.live || []).map((match) => ({
        ...match,
        court: sportsData.matches[court]?.court
      }))
    ),
    upcoming: otherCourtKeys.flatMap((court) =>
      (sportsData.matches[court]?.upcoming || []).map((match) => ({
        ...match,
        court: sportsData.matches[court]?.court
      }))
    )
  };
};

export const getVisibleCourts = (sportsData) => {
  const courts = MAIN_COURTS.map((courtName) => ({
    courtName,
    matches: getMainCourtMatches(sportsData, courtName)
  }));

  const otherCourtsMatches = getOtherCourtsMatches(sportsData);
  if (otherCourtsMatches) {
    courts.push({ courtName: "Other Courts", matches: otherCourtsMatches });
  }

  return courts.filter((court) => hasAnyMatches(court.matches));
};
